/* Enhance Broadcast's existing form; Recharge remains the owner of selling_plan. */
(() => {
  if (window.__rgbCleanseEnhancements) return;
  window.__rgbCleanseEnhancements = true;
  const roots = new Map();
  function init(root) {
    if (roots.has(root)) return;
    const source = root.querySelector('[data-rgb-product]');
    if (!source) return;
    const product = JSON.parse(source.textContent);
    // Keep alternate-template previews on rgb-cleanse during Broadcast section rendering.
    customElements.whenDefined('product-info').then(() => {
      const build = root.buildRequestUrlWithParams.bind(root);
      root.buildRequestUrlWithParams = (...args) => {
        const url = new URL(build(...args), location.origin);
        if (root.dataset.rgbView) url.searchParams.set('view', root.dataset.rgbView); else url.searchParams.delete('view');
        return url.pathname + url.search;
      };
      // Default only an unselected landing to the available five-day option.
      // Explicit variant links and all subsequent customer selections are retained.
      if (!new URLSearchParams(location.search).has('variant') && product.options.length === 1) {
        customElements.whenDefined('variant-selects').then(() => {
          const days = root.dataset.rgbDefaultDays;
          const fiveDay = days && product.variants.find(v => v.available && new RegExp('^' + days + '[ -]*days?$', 'i').test(v.option1 || v.title));
          const input = fiveDay && [...root.querySelectorAll('.radio__button input')].find(el => el.value === fiveDay.option1);
          if (input && !input.checked) {
            // Broadcast focuses the replacement radio after rendering. Do not show
            // a keyboard ring for this automatic selection; restore it on interaction.
            root.classList.add('rgb-auto-selected');
            const interaction = new AbortController();
            const restoreFocusStyles = () => {
              root.classList.remove('rgb-auto-selected');
              interaction.abort();
            };
            document.addEventListener('pointerdown', restoreFocusStyles, {capture:true, signal:interaction.signal});
            document.addEventListener('keydown', restoreFocusStyles, {capture:true, signal:interaction.signal});
            input.click();
          }
        });
      }
      const updateURL = root.updateURL.bind(root);
      root.updateURL = (...args) => {
        updateURL(...args);
        const url = new URL(location.href); if (root.dataset.rgbView) url.searchParams.set('view', root.dataset.rgbView); else url.searchParams.delete('view');
        history.replaceState({}, '', url.pathname + url.search);
      };
    });
    const prices = JSON.parse(root.querySelector('[data-rgb-prices]').textContent);
    const form = root.querySelector('form[data-product-form]');
    const money = cents => window.theme?.formatMoney ? window.theme.formatMoney(cents, window.theme.moneyFormat) : new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
    const text = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
    const widget = root.querySelector('recharge-subscription-widget');
    const expanded = document.createElement('div'); expanded.className = 'rgb-subscription-details';
    const frequencyLabel = document.createElement('label'); frequencyLabel.textContent = 'Delivery Frequency';
    const frequency = document.createElement('select'); frequency.id = `rgb-frequency-${product.id}-${root.dataset.section}`;
    frequency.setAttribute('aria-label', 'Subscription delivery frequency'); frequencyLabel.htmlFor = frequency.id;
    const benefits = document.createElement('ul'); expanded.append(frequencyLabel, frequency, benefits);
    let planSignature = '', benefitSignature = '', defaultPurchaseInitialized = false;
    frequency.addEventListener('change', async () => {
      const selected = frequency.value;
      const radio = widget?.shadowRoot?.querySelector('input[value="subscription"]');
      if (!radio) return;
      radio.click(); await widget.updateComplete;
      const plans = widget.shadowRoot.querySelector('rc-selling-plans');
      if (plans) { await plans.updateComplete; const native = plans.shadowRoot?.querySelector('select'); if (native) { native.value=selected; native.dispatchEvent(new Event('change',{bubbles:true})); } }
      setTimeout(update, 0);
    });
    function updateSubscription(variant, allocation) {
      if (!widget?.shadowRoot?.querySelector('.rc-purchase-option__subscription')) return;
      // Initialize once after Recharge is ready; preserve subsequent customer choices.
      if (!defaultPurchaseInitialized && widget.state === 'ready') {
        const onetime = widget.shadowRoot.querySelector('input[value="onetime"]');
        defaultPurchaseInitialized = true;
        if (!product.requires_selling_plan && !variant.requires_selling_plan && onetime && !onetime.disabled) onetime.click();
      }
      expanded.classList.toggle('is-selected', widget.purchaseOption === 'subscription');
      if (!expanded.isConnected) {widget.after(expanded);widget.closest('.shopify-app-block').classList.add('rgb-recharge-expanded');}
      const allocations = variant.selling_plan_allocations || [];
      expanded.hidden = !allocations.length;
      const plans = (product.selling_plan_groups || []).flatMap(g => g.selling_plans || []);
      const signature = allocations.map(a => a.selling_plan_id).join(',');
      if (signature !== planSignature) {
        frequency.replaceChildren(); allocations.forEach(a => { const plan=plans.find(p=>p.id===a.selling_plan_id);const option=document.createElement('option');option.value=a.selling_plan_id;option.textContent=plan?.name || 'Subscription';frequency.append(option); });
        planSignature=signature;
      }
      const current = allocation || allocations.find(a => String(a.selling_plan_id) === String(widget.sellingPlanId)) || allocations[0];
      if (current && frequency.value !== String(current.selling_plan_id)) frequency.value=String(current.selling_plan_id);
      const discount = current && variant.price > 0 ? Math.max(0,Math.round((variant.price-current.price)*100/variant.price)) : 0;
      const raw = widget.settings?.benefits || '';
      const key=raw+'|'+discount;
      if(key!==benefitSignature){
        benefits.replaceChildren();const doc=new DOMParser().parseFromString(raw,'text/html');
        doc.querySelectorAll('li').forEach(item=>{let content=item.textContent.trim();if(content.includes('{discount}')&&!discount)return;content=content.replaceAll('{discount}',discount+'%');const li=document.createElement('li');li.textContent=content;
          if (/^free shipping[.!]?$/i.test(content)) {
            const value = document.createElement('em');
            value.textContent = '($9.99 VALUE)';
            li.append(document.createTextNode(' '), value);
          }
          benefits.append(li);});benefitSignature=key;
      }
    }
    function update() {
      const variant = product.variants.find(v => String(v.id) === form?.querySelector('[name="id"]')?.value);
      if (!variant) return;
      const planId = form.querySelector('[name="selling_plan"]')?.value;
      const allocation = variant.selling_plan_allocations?.find(p => String(p.selling_plan_id) === planId);
      updateSubscription(variant, allocation);
      const onePrices = widget?.shadowRoot?.querySelector('[part~="rc-purchase-option__onetime"] [part~="rc-purchase-option__prices"]');
      if (onePrices) {
        let compare = onePrices.querySelector('[data-rgb-compare]');
        if (!compare) { compare=document.createElement('s');compare.dataset.rgbCompare='';compare.style.cssText='color:#888;font-weight:400';onePrices.prepend(compare); }
        compare.hidden = !(variant.compare_at_price > variant.price);
        text(compare, compare.hidden ? '' : money(variant.compare_at_price));
      }
      const valid = (!planId && !variant.requires_selling_plan) || !!allocation;
      const amount = allocation ? allocation.price : variant.price;
      const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
      const button = form.querySelector('[data-add-to-cart]');
      const label = button?.querySelector('[data-add-to-cart-text]');
      if (button && !button.disabled && valid) text(label, `BUY NOW ${quantity === 1 ? (allocation ? prices[variant.id]?.plans[planId] : prices[variant.id]?.price) || money(amount) : money(amount * quantity)}`);
      const savings = Math.max(0, Math.max(variant.price, variant.compare_at_price || 0) - amount) * quantity;
      const savingsEl = root.querySelector('[data-rgb-savings]');
      if (savingsEl) { savingsEl.hidden = !valid || savings <= 0; text(savingsEl, savings > 0 ? `TOTAL SAVINGS ${money(savings)}` : ''); }
    }
    form?.addEventListener('submit', event => {
      const variant = product.variants.find(v => String(v.id) === form.querySelector('[name="id"]')?.value);
      const id = form.querySelector('[name="selling_plan"]')?.value;
      if (variant && ((variant.requires_selling_plan && !id) || (id && !variant.selling_plan_allocations.some(a => String(a.selling_plan_id) === id)))) {
        event.preventDefault(); event.stopImmediatePropagation();
        const error = root.querySelector('[data-rgb-plan-error]') || document.createElement('p');
        error.setAttribute('data-rgb-plan-error',''); error.setAttribute('role','alert');
        text(error, 'Please select an available subscription frequency before continuing.');
        if (!error.isConnected) form.append(error);
      } else root.querySelector('[data-rgb-plan-error]')?.remove();
    }, true);
    root.addEventListener('change', () => { update(); setTimeout(update, 100); });
    root.querySelectorAll('[data-rgb-media]').forEach(button => button.addEventListener('click', () => {
      const media = [...root.querySelectorAll('[data-media-id]')].find(e => e.getAttribute('data-media-id') === button.dataset.rgbMedia && e.matches('[data-slide]'));
      if (!media) return;
      media.dispatchEvent(new CustomEvent('theme:media:select', {bubbles:true, detail:{id:button.dataset.rgbMedia}}));
      root.querySelector('[data-product-media-list]')?.scrollTo({left:media.offsetLeft, behavior:'smooth'});
      root.querySelectorAll('[data-rgb-media]').forEach(b => b.setAttribute('aria-current', String(b === button)));
    }));
    // Recharge updates native input values asynchronously, sometimes without a DOM event.
    const timer = setInterval(() => { if (!root.isConnected) { clearInterval(timer); roots.delete(root); return; } update(); }, 300);
    roots.set(root, timer); update();
    const column = root.querySelector('.form__width');
    const details = root.querySelector('.rgb-description-toggle');
    const mobile = matchMedia('(max-width:749px)');
    const openDescription = () => { if (details) details.open = true; };
    mobile.addEventListener('change', openDescription);
    const paymentBlock = root.querySelector('.rgb-payments')?.closest('.product__block');
    const buttonBlock = root.querySelector('.product__block:has(product-form)');
    if (paymentBlock && buttonBlock) buttonBlock.after(paymentBlock);
    const warning = root.querySelector('.rgb-california-warning');
    if (warning && column) { warning.style.order = '75'; column.append(warning); }
    loadReviews(root, product);

  }
  async function loadReviews(root, product) {
    const widget = root.querySelector('.reviews-io-nuggets-widget, [data-rgb-review-source]');
    const summary = root.querySelector('[data-rgb-review-summary]');
    const ratingWidget = root.querySelector('.reviews-io-rating-bar-widget');
    if (ratingWidget) ratingWidget.hidden = true;
    if (!widget || !summary || !widget.dataset.sku?.replaceAll(';', '').trim()) return;
    const params = new URLSearchParams({type:'product_review', store:widget.dataset.storeName || 'rawgeneration.myshopify.com', sku:widget.dataset.sku, sort:'date_desc', per_page:'5', page:'1', widget:'polaris'});
    try {
      const response = await fetch(`https://api.reviews.io/timeline/data?${params}`);
      if (!response.ok) return;
      const data = await response.json();
      const count = Number(data.stats?.review_count || 0);
      const rating = Number(data.stats?.average_rating || 0);
      if (!count || !Number.isFinite(rating)) return;
      const heading = summary.querySelector('[data-rgb-review-heading]');
      const score = document.createElement('strong'); score.textContent = rating.toFixed(2);
      const stars = document.createElement('span'); stars.className = 'rgb-review-stars'; stars.textContent = '★★★★★'; const fillStars=document.createElement('span');fillStars.textContent='★★★★★';fillStars.style.width=`${Math.max(0,Math.min(100,rating*20))}%`;fillStars.setAttribute('aria-hidden','true');stars.append(fillStars); stars.setAttribute('aria-label', `${rating.toFixed(2)} out of 5 stars`);
      const caption = document.createElement('p'); caption.textContent = `Based on ${count.toLocaleString()} product reviews`;
      heading.append(score, stars, caption);
      // The header and summary share one product-scoped response, not store totals.
      const ratingBar = root.querySelector('.reviews-io-rating-bar-widget');
      if (ratingBar) {
        let productRating = root.querySelector('[data-rgb-product-rating]');
        if (!productRating) {
          productRating = document.createElement('a');
          productRating.className = 'rgb-product-rating';
          productRating.setAttribute('data-rgb-product-rating', '');
          summary.id = summary.id || 'rgb-product-review-summary';
          productRating.href = '#' + summary.id;
          ratingBar.before(productRating);
        }
        const label = document.createElement('span');
        label.textContent = `${rating.toFixed(2)} / 5 · ${count.toLocaleString()} reviews`;
        productRating.replaceChildren(stars.cloneNode(true), label);
        ratingBar.hidden = true;
      }

      const histogram = summary.querySelector('[data-rgb-histogram]');
      const buckets = data.aggregations?.ratings?.buckets || [];
      const total = buckets.reduce((n, b) => n + Number(b.doc_count), 0);
      if (total) for (let i = 5; i >= 1; i--) {
        const percent = Math.round(100 * Number(buckets.find(b => Number(b.key) === i)?.doc_count || 0) / total);
        const row = document.createElement('div'); row.className='rgb-histogram-row';
        const label = document.createElement('div'); label.className='rgb-histogram-label';
        const left = document.createElement('span'); left.textContent=`${i} star`;
        const right = document.createElement('span'); right.textContent=`${percent}%`;
        label.append(left,right);
        const track=document.createElement('div'); track.className='rgb-histogram-track';
        const fill=document.createElement('div');fill.className='rgb-histogram-fill';fill.style.width=`${percent}%`;
        track.append(fill);row.append(label,track);histogram.append(row);
      }
      summary.hidden=false;
      // The shared Liquid snippet renders an audited, verified customer quote.
    } catch(error) { console.warn('RGB Reviews.io summary could not load. The full reviews widget remains available.'); }
  }
  function scan() { document.querySelectorAll('.rgb-cleanse').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', e => { roots.forEach((timer, root) => {if(e.target.contains(root)){clearInterval(timer);roots.delete(root);}}); });
})();

/* Desktop main-image navigation; the original mobile gallery is untouched. */
(() => {
  const desktop = matchMedia('(min-width:750px)');
  function setup(root) {
    if (!['rgb-cleanse','rgb-routine'].includes(root.dataset.rgbView)) return;
    const list = root.querySelector('[data-product-media-list]');
    if (!list || list.querySelector('.rgb-desktop-gallery')) return;
    const slides = [...list.querySelectorAll(':scope > [data-slide][data-type="image"]')];
    if (slides.length < 2) return;
    const gallery = document.createElement('div');
    gallery.className = 'rgb-desktop-gallery';
    gallery.setAttribute('role','region');gallery.setAttribute('aria-label','Product image gallery');
    const main = document.createElement('button');main.type = 'button';main.className = 'rgb-desktop-gallery__image';
    const image = document.createElement('img');main.append(image);
    const count = document.createElement('span');count.className = 'rgb-desktop-gallery__count';count.setAttribute('aria-live','polite');
    let index = 0;
    function show(next) {
      index = (next + slides.length) % slides.length;
      const original = slides[index].querySelector('img');
      for(const attr of ['src','srcset','alt','width','height']) {
        const value = original.getAttribute(attr);if(value!==null)image.setAttribute(attr,value);else image.removeAttribute(attr);
      }
      image.sizes = '(min-width:1400px) 700px, 55vw';
      main.setAttribute('aria-label',`Zoom product image ${index+1} of ${slides.length}`);
      count.textContent = `${index+1} / ${slides.length}`;
      gallery.dataset.imageIndex = String(index);
    }
    main.addEventListener('click',()=>slides[index].querySelector('[data-zoom-image]')?.click());
    gallery.append(main);
    for(const [direction,label,step] of [['prev','Previous image',-1],['next','Next image',1]]) {
      const button = document.createElement('button');button.type='button';button.className=`rgb-desktop-gallery__arrow rgb-desktop-gallery__arrow--${direction}`;button.setAttribute('aria-label',label);
      button.innerHTML=`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="${step<0?'M15 5l-7 7 7 7':'M9 5l7 7-7 7'}"/></svg>`;
      button.addEventListener('click',()=>show(index+step));gallery.append(button);
    }
    gallery.append(count);
    gallery.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1));}});
    slides[0].classList.add('rgb-desktop-original');
    list.prepend(gallery);show(0);
  }
  function scan(){document.querySelectorAll('.rgb-cleanse').forEach(setup);}
  document.addEventListener('keydown',event=>{if(['Tab','ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key))document.querySelectorAll('.rgb-cleanse').forEach(r=>r.classList.add('rgb-keyboard-navigation'));},true);
  document.addEventListener('pointerdown',()=>document.querySelectorAll('.rgb-cleanse').forEach(r=>r.classList.remove('rgb-keyboard-navigation')),true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();
